import { ContactEmployee } from '@/api/contact-employee/contact-employee.types';
import { InfoPair } from '@/components/base/info-pair.component';
import { List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CompanyInformationProps {
  contactEmployee: ContactEmployee | undefined;
  isLoading: boolean;
}

export function CompanyInformation({
  contactEmployee,
  isLoading,
}: CompanyInformationProps) {
  const { t } = useTranslation('customer');

  return (
    <>
      <Typography variant={'subtitle2'}>{t('account.myData.companyInfo')}</Typography>
      <List>
        <InfoPair
          label={t('account.myData.companyFields.customerNumber')}
          value={contactEmployee?.businessPartner?.id}
          isLoading={isLoading}
        />
        <InfoPair
          label={t('account.myData.companyFields.name')}
          value={contactEmployee?.businessPartner?.name}
          isLoading={isLoading}
        />
        <InfoPair
          label={t('account.myData.companyFields.mainContact')}
          value={contactEmployee?.businessPartner?.defaultContactPersonName}
          isLoading={isLoading}
        />
      </List>
    </>
  );
}
